import { cleanMessageForDisplay } from '../utils/transcriptSanitizer';

/**
 * Normalize API message rows for dashboard UI.
 * User turns are de-duplicated for display: transcripts saved before the recogniser
 * merge fix can contain repeated fragments ("do you think do you think you would …").
 * The stored row is untouched — only what we render is tidied.
 */
export function normalizeDashboardMessages(messages) {
  if (!Array.isArray(messages)) return [];
  return messages
    .map((m) => {
      const role = m?.role === 'user' ? 'user' : 'assistant';
      const raw = String(m?.content ?? '').trim();
      return {
        role,
        content: cleanMessageForDisplay(raw, role) || raw,
        timestamp: m?.timestamp ?? m?.message_timestamp ?? null,
      };
    })
    .filter((m) => m.content.length > 0);
}
